// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__TLc5j"};